// src/main.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { configureAuth } from './api/auth';
import { loadEnvConfig } from './config/env';

async function initializeApp() {
  try {
    // Load environment config first
    await loadEnvConfig();
    // Configure Amplify auth with the loaded config
    await configureAuth();
    
    // Only render the app after configuration is complete
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Failed to initialize application:', error);
  }
}

initializeApp();
